export default __webpack_public_path__ + "static/14_37-36c6c51793bc8ce1f9a1356ff856286a.png";